export function exportCsv(
  headers: string[],
  rows: Record<string, string | number>[],
  filename: string
): void {
  const headerLine = headers.join(",");
  const dataLines = rows.map((row) =>
    headers.map((h) => (row[h] !== undefined ? row[h] : "")).join(",")
  );

  const csvContent = [headerLine, ...dataLines].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
